const DAY_ORDER = [
   { key: "Monday", full: "Monday", short: "Mon" },
   { key: "Tuesday", full: "Tuesday", short: "Tue" },
   { key: "Wednesday", full: "Wednesday", short: "Wed" },
   { key: "Thursday", full: "Thursday", short: "Thu" },
   { key: "Friday", full: "Friday", short: "Fri" },
   { key: "Saturday", full: "Saturday", short: "Sat" },
   { key: "Sunday", full: "Sunday", short: "Sun" },
]

export { DAY_ORDER }
